import { CheckboxGroupField, Field, Text } from '@payaca/ambrosia';
import CurrencyValue from '@payaca/components/currencyValue/CurrencyValue';
import { FC } from 'react';

import useGetMyAccountGrants from '@/api/queries/me/useGetMyAccountGrants';
import { useMyAccountHasFeature } from '@/api/queries/me/useGetMyAccountFeatures';

export const useProposalTemplateGrants = (grantIds: string[]) => {
  const hasGrantsOnProposals = useMyAccountHasFeature('hasGrantsOnProposals');
  const { grants: catalogue, isLoading } = useGetMyAccountGrants({
    enabled: hasGrantsOnProposals,
  });

  const selected = catalogue.filter((grant) => grantIds.includes(grant.id));

  return {
    isVisible: hasGrantsOnProposals && !isLoading && catalogue.length > 0,
    catalogue,
    selected,
  };
};

export const ProposalTemplateGrantsControl: FC<{
  grantIds: string[];
  hasPaymentSchedule: boolean;
  onChange: (grantIds: string[]) => void;
}> = (props) => {
  const { grantIds, hasPaymentSchedule, onChange } = props;
  const { isVisible, catalogue } = useProposalTemplateGrants(grantIds);

  if (!isVisible) return null;

  const options = catalogue.map((grant) => ({
    value: grant.id,
    label: (
      <span className="flex flex-1 justify-between gap-3">
        <Text as="span">{grant.name}</Text>
        <Text as="span">
          <CurrencyValue {...grant.availableAmount} hideZeroMinorUnits />
        </Text>
      </span>
    ),
  }));

  return (
    <Field.Legacy name="data.grantIds">
      <Field.Label>Grants</Field.Label>
      {hasPaymentSchedule && (
        <Field.HelperText>
          Grants will be added to the end of the payment schedule. The later
          payments in the schedule may be reduced in amount or removed entirely
          if grants cover their value.
        </Field.HelperText>
      )}
      <CheckboxGroupField
        emphasised
        className="lg:w-1/2"
        value={grantIds}
        options={options}
        onChange={onChange}
      />
    </Field.Legacy>
  );
};
